<template>
    <span>
        <editarcomunicado></editarcomunicado>
    </span>
</template>

<script>
import Editarcomunicado from '@/components/Editar-Comunicado';

export default {
    name: 'cadeditarcomunicado',
    components: {
        Editarcomunicado
    }
};
</script>